
$(window).on('load scroll', function (){

  var item = $('.fadein');
  var isshow = 'isshow';
  
  item.each(function(){
  
    var itemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    if(scrollPos > itemOffset - wh + 160 ){
      $(this).addClass(isshow);
    }
  });

});


$(window).on('load scroll', function (){

  var item = $('.fadein-up');
  var isshow = 'isshow';
  
  item.each(function(){
  
    var itemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    if(scrollPos > itemOffset - wh + 200 ){
      $(this).addClass(isshow);
    }
  });

});